let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("hm3Yv")).then(() => parcelRequire('9ajce'));